export default function ArrowLeftCircle({ className, backgroundColor }) {
    return (
        <svg className={className} width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="16" cy="16" r="16" fill={backgroundColor}/>
            <path d="M21.0389 15.6556H12.1153" stroke="currentColor" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round"/>
            <path d="M15.8098 11.839L11.3141 15.6556L15.8098 19.4858" stroke="currentColor" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round"/>
        </svg>
    )
}
